<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Acknowledgements</p>
<p class="noindent">This book would not have been possible without the helpful contributions of so many. I would like to first thank my editor, John Wilkinson, who not only suggested this project to me, but also provided guidance and encouragement throughout.</p>
<p class="indent">A huge thank-you goes to Michael Finger, senior editor of <i>Memphis</i> magazine. He generously shared his research and insight into several of the stories that appear in this book. He is a wonderful writer and I am humbled by his gracious assistance.</p>
<p class="indent">I am deeply indebted to Andy Carter of the Memphis Public Library who aided in the inclusion of many of the beautiful and historic photos in this book.</p>
<p class="indent">I am also grateful to my husband, Michael J. Simpson, who is not only my partner in life, but has turned out to be a great research assistant as well.</p>
<p class="indent">There are a number of other people who offered their time, knowledge and talents to this project. These fabulous folks include Foster Bunday, Ed Frank, Paul V. Isbell, Jim Little, Robert J. McNamara, Chris Ratcliff, Tomás N. Romero and Amie Vanderford.</p>
<p class="indent">And, as always, I want to thank my family and friends for their support and encouragement.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?04b20598